import { createRoute } from '@tanstack/react-router';
import { IconFileText } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { QuoteList } from './QuoteList';
import { QuoteEdit } from './QuoteEdit';
import { MarketingList } from './MarketingList';
import { CampaignDetail } from './CampaignDetail';
import { MarketShare } from './MarketShare';
import {
  CAMPAIGNS, CAMPAIGN_DETAILS, CONTINGENCIES, FEE_POOL, GIFTS, GOLDEN_QUOTE_LINES, INQUIRIES, PLUS_SERVICES, PRICING_SEATS, QUOTES, RATE_OPTIONS, RFQS, SURCHARGES, TEMPLATES,
} from './fixtures';

// H-02a: Báo giá — danh sách. Soạn báo giá (H-02b: /ezy/quotes/edit), iPad / điện thoại (H-02c), Marketing (H-05) thêm sau.
const sales: EzyModule = {
  nav: { key: 'sales', label: 'Báo giá', icon: IconFileText, section: 'Bán hàng', items: [{ key: 'quotes', label: 'Báo giá', to: '/ezy/quotes' }, { key: 'marketing', label: 'Marketing', to: '/ezy/marketing' }, { key: 'market-share', label: 'Market Share', to: '/ezy/market-share' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/quotes', component: QuoteList }),
    createRoute({ getParentRoute: () => parent, path: '/quotes/edit', component: QuoteEdit }),
    createRoute({ getParentRoute: () => parent, path: '/marketing', component: MarketingList }),
    createRoute({ getParentRoute: () => parent, path: '/market-share', component: MarketShare }),
    createRoute({ getParentRoute: () => parent, path: '/marketing/$campaignId', component: CampaignDetail }),
  ],
  fixtures: (register) => {
    register('quote', QUOTES);
    register('quoteLine', GOLDEN_QUOTE_LINES);
    register('quoteFee', FEE_POOL);
    register('quotePlus', PLUS_SERVICES);
    register('quoteSurcharge', SURCHARGES);
    register('quoteContingency', CONTINGENCIES);
    register('quoteRate', RATE_OPTIONS);
    register('quoteInquiry', INQUIRIES);
    register('quoteSeat', PRICING_SEATS);
    register('mktCampaign', CAMPAIGNS);
    register('mktCampaignDetail', CAMPAIGN_DETAILS);
    register('mktTemplate', TEMPLATES);
    register('mktGift', GIFTS);
    register('mktRfq', RFQS);
  },
};
export default sales;
